module.exports = __webpack_public_path__ + "static/media/step3desktop.de283bc7.png";